module.exports = __webpack_public_path__ + "static/media/delete_chosen.bfd3f297.png";